<div class="container-fluid registro-marcajes">

  <div class="rm-header rounded">
    <div class="row align-items-center">
      <div class="col-md-1 text-center"><i class="fa-solid fa-business-time fa-2xl"></i></div>
      <div class="col-md-11">
        <div class="rm-header-title">HORAS EXTRAS — CAPTURA QUINCENAL</div>
        <div class="rm-header-sub">{{ PAD10NOM }} <span *ngIf="PAD10COD">(#{{ PAD10COD }})</span></div>
      </div>
    </div>
  </div>

  <div class="rm-context">
    <div class="row align-items-end">
      <div class="col-md-2">
        <label class="rm-label">Quincena Inicio</label>
        <input type="date" class="form-control form-control-sm" [(ngModel)]="FEC_INI" disabled>
      </div>
      <div class="col-md-2">
        <label class="rm-label">Quincena Fin</label>
        <input type="date" class="form-control form-control-sm" [(ngModel)]="FEC_FIN" disabled>
      </div>
      <div class="col-md-2">
        <label class="rm-label"># Planilla a Registrar</label>
        <input type="text" class="form-control form-control-sm" [(ngModel)]="PLA28CON" placeholder="Planilla" disabled>
      </div>
      <div class="col-md-6 text-end">
        <button type="button" class="btn btn-secondary btn-sm me-1" (click)="cargarQuincena()" [disabled]="cargando">
          <i class="fa fa-refresh"></i> Recargar
        </button>
        <button type="button" class="btn btn-primary btn-sm me-1" (click)="guardar()" [disabled]="guardando || permisos.GRABAR !== 'S'">
          <i class="fa fa-save"></i> Guardar marcajes
        </button>
        <button type="button" class="btn btn-info btn-sm me-1" (click)="calcular()" [disabled]="calculando">
          <i class="fa fa-calculator"></i> Calcular
        </button>
        <button type="button" class="btn btn-success btn-sm me-1" (click)="aplicar()" [disabled]="aplicando || !previewVisible">
          <i class="fa fa-check"></i> Aplicar a planilla
        </button>
        <button type="button" class="btn btn-outline-danger btn-sm" (click)="reversar()" [disabled]="!PLA28CON">
          <i class="fa fa-undo"></i> Reversar
        </button>
      </div>
    </div>
  </div>

  <!-- Matriz de marcajes -->
  <div class="rm-table-wrap" *ngIf="!cargando; else loading">
    <table class="table table-bordered table-sm rm-matriz">
      <thead class="table-light">
        <tr>
          <th class="rm-col-fecha">Fecha</th>
          <th class="rm-col-dia">Día</th>
          <th>Tipo</th>
          <th class="rm-col-marc">Base inicio</th>
          <th class="rm-col-marc">Base fin</th>
          <th class="rm-col-marc">Entrada</th>
          <th class="rm-col-marc">Salida</th>
          <th class="rm-col-marc">Almuerzo Ini</th>
          <th class="rm-col-marc">Almuerzo Fin</th>
          <th>Estado</th>
          <th class="rm-col-acc"></th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let d of dias; trackBy: trackByFec">
          <tr [class.rm-feriado]="d.ES_FERIADO" [class.rm-descanso]="d.ES_DESCANSO">
            <td>{{ d.FEC }}</td>
            <td>{{ d.DIA }}</td>
            <td>
              <span *ngIf="d.ES_FERIADO" class="badge bg-danger">Feriado</span>
              <span *ngIf="d.ES_DESCANSO && !d.ES_FERIADO" class="badge bg-secondary">Descanso</span>
              <span *ngIf="!d.ES_DESCANSO && !d.ES_FERIADO" class="badge bg-light text-dark">{{ d.TIP_JORN || '—' }}</span>
            </td>
            <td>
              <span><input type="text" class="form-control form-control-sm" [(ngModel)]="d._HOR_INIEdit" [disabled]="checkMarcaje(d)" placeholder="HH:MM"/></span>
            </td>
            <td>
              <span><input type="text" class="form-control form-control-sm" [(ngModel)]="d._HOR_FINEdit" [disabled]="checkMarcaje(d)" placeholder="HH:MM"/></span>
            </td>
            <ng-container *ngIf="d.MARCAJES.length === 0">
              <td colspan="5" class="text-muted text-center">Sin marcajes</td>
            </ng-container>
            <ng-container *ngIf="d.MARCAJES.length > 0">
              <td><input type="text" class="form-control form-control-sm" [(ngModel)]="d.MARCAJES[0]._hliEdit" (input)="onCeldaEdit(d.MARCAJES[0])" [disabled]="d.MARCAJES[0].EST === 'P'" placeholder="HH:MM"></td>
              <td><input type="text" class="form-control form-control-sm" [(ngModel)]="d.MARCAJES[0]._hlfEdit" (input)="onCeldaEdit(d.MARCAJES[0])" [disabled]="d.MARCAJES[0].EST === 'P'" placeholder="HH:MM"></td>
              <td><input type="text" class="form-control form-control-sm" [(ngModel)]="d.MARCAJES[0]._haiEdit" (input)="onCeldaEdit(d.MARCAJES[0])" [disabled]="d.MARCAJES[0].EST === 'P'" placeholder="HH:MM"></td>
              <td><input type="text" class="form-control form-control-sm" [(ngModel)]="d.MARCAJES[0]._hafEdit" (input)="onCeldaEdit(d.MARCAJES[0])" [disabled]="d.MARCAJES[0].EST === 'P'" placeholder="HH:MM"></td>
              <td>
                <span class="badge" [class.bg-warning]="d.MARCAJES[0].EST === 'C'" [class.bg-success]="d.MARCAJES[0].EST === 'P'" [class.bg-danger]="d.MARCAJES[0].EST === 'N'">
                  {{ d.MARCAJES[0].EST === 'P' ? 'Pagado' : (d.MARCAJES[0].EST === 'C' ? 'Capturado' : 'Anulado') }}
                </span>
              </td>
            </ng-container>

            <td class="text-center">
              <button *ngIf="!tienePagados(d)" class="btn btn-sm btn-link" (click)="agregarMarcaje(d)" title="Agregar turno" [disabled]="permisos.GRABAR !== 'S'">
                <i class="fa fa-plus"></i>
              </button>
              <button *ngIf="d.MARCAJES.length > 0 && !tienePagados(d)" class="btn btn-sm btn-link text-danger"
                      (click)="quitarMarcaje(d, 0)" title="Quitar primer turno"
                      [disabled]="permisos.GRABAR !== 'S'">
                <i class="fa fa-trash"></i>
              </button>
            </td>
          </tr>

          <!-- Turnos adicionales (turno partido) -->
          <tr *ngFor="let m of d.MARCAJES.slice(1); let j = index" class="rm-turno-extra">
            <td colspan="4" class="text-end text-muted small">↳ turno adicional</td>
            <td><input type="text" class="form-control form-control-sm" [(ngModel)]="m._hliEdit" (input)="onCeldaEdit(m)" [disabled]="m.EST === 'P'" placeholder="HH:MM"></td>
            <td><input type="text" class="form-control form-control-sm" [(ngModel)]="m._hlfEdit" (input)="onCeldaEdit(m)" [disabled]="m.EST === 'P'" placeholder="HH:MM"></td>
            <td><input type="text" class="form-control form-control-sm" [(ngModel)]="m._haiEdit" (input)="onCeldaEdit(m)" [disabled]="m.EST === 'P'" placeholder="HH:MM"></td>
            <td><input type="text" class="form-control form-control-sm" [(ngModel)]="m._hafEdit" (input)="onCeldaEdit(m)" [disabled]="m.EST === 'P'" placeholder="HH:MM"></td>
            <td>
              <span class="badge" [class.bg-warning]="m.EST === 'C'" [class.bg-success]="m.EST === 'P'" [class.bg-danger]="m.EST === 'N'">
                {{ m.EST === 'P' ? 'Pagado' : (m.EST === 'C' ? 'Capturado' : 'Anulado') }}
              </span>
            </td>
            <td class="text-center">
              <button *ngIf="m.EST !== 'P'" class="btn btn-sm btn-link text-danger"
                      (click)="quitarMarcaje(d, j + 1)" title="Quitar este turno">
                <i class="fa fa-trash"></i>
              </button>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>

  <ng-template #loading>
    <div class="text-center py-4">
      <i class="fa fa-spinner fa-spin fa-2xl"></i>
      <div>Cargando quincena...</div>
    </div>
  </ng-template>

  <!-- Preview del cálculo -->
  <div class="rm-preview mt-3" *ngIf="previewVisible">
    <h5 class="mb-2"><i class="fa fa-calculator me-1"></i>Desglose calculado</h5>

    <div class="row">
      <div class="col-md-8">
        <table class="table table-sm table-striped table-hover rm-preview-detalle">
          <thead>
            <tr>
              <th>Fecha</th>
              <th>Concepto</th>
              <th>Descripción</th>
              <th class="text-end">Horas</th>
              <th class="text-end">Factor</th>
              <th class="text-end">Rata</th>
              <th class="text-end">Monto</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let l of preview; trackBy: trackByLin">
              <td>{{ l.FEC }}</td>
              <td><span class="badge bg-light text-dark">{{ l.COD }}</span></td>
              <td>{{ l.DES }}</td>
              <td class="text-end">{{ l.CAN | number:'1.2-2' }}</td>
              <td class="text-end">{{ l.FAC | number:'1.4-4' }}</td>
              <td class="text-end">{{ l.RAT | number:'1.4-4' }}</td>
              <td class="text-end">{{ l.MON | number:'1.2-2' }}</td>
            </tr>
            <tr *ngIf="preview.length === 0">
              <td colspan="6" class="text-center text-muted">Sin horas extras para este rango</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="col-md-4">
        <table class="table table-sm rm-preview-resumen">
          <thead>
            <tr>
              <th>Concepto</th>
              <th>Descripción</th>
              <th class="text-end">Horas</th>
              <th class="text-end">Monto</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let t of totalesConcepto">
              <td><span class="badge bg-light text-dark">{{ t.COD }}</span></td>
              <td>{{ t.DES }}</td>
              <td class="text-end">{{ t.CAN | number:'1.2-2' }}</td>
              <td class="text-end">{{ t.MON | number:'1.2-2' }}</td>
            </tr>
            <tr class="table-active">
              <td class="fw-bold">TOTAL</td>
              <td></td>
              <td class="text-end fw-bold">{{ totalGeneral | number:'1.2-2' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <div class="rm-footer mt-3 text-end">
    <button class="btn btn-outline-secondary btn-sm" (click)="emitirCancelar()">
      <i class="fa fa-times"></i> Cerrar
    </button>
  </div>

</div>
